import React from 'react';
import { Card, Grid } from '@mui/material';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftButton from 'components/SoftButton';

const PartnerInfo = () => {
  return (
    <SoftBox py={3}>
      <Card>
        <SoftBox p={3}>
          <SoftBox mb={3}>
            <SoftTypography variant="h4" fontWeight="medium">
              Werden Sie UDS Partner
            </SoftTypography>
          </SoftBox>
          
          <Grid container spacing={3}>
            <Grid item xs={12} lg={8}>
              <SoftBox mb={3}>
                <SoftTypography variant="body2" color="text">
                  Als UDS Partner profitieren Sie von zahlreichen Vorteilen und können Ihren Kunden erstklassige Cloud- und IT-Dienste anbieten.
                </SoftTypography>
              </SoftBox>
              
              <SoftBox mb={3}>
                <SoftTypography variant="h5" fontWeight="medium">
                  Ihre Vorteile als Partner:
                </SoftTypography>
                <SoftBox component="ul" pl={2}>
                  <li>
                    <SoftTypography variant="button" color="text" fontWeight="regular">
                      Attraktive Wiederverkäufer-Margen auf IaaS und SaaS Produkte
                    </SoftTypography>
                  </li>
                  <li>
                    <SoftTypography variant="button" color="text" fontWeight="regular">
                      Eigenes Partner-Dashboard mit Kundenverwaltung
                    </SoftTypography>
                  </li>
                  <li>
                    <SoftTypography variant="button" color="text" fontWeight="regular">
                      Automatisierte Abrechnung und Rechnungsstellung
                    </SoftTypography>
                  </li>
                  <li>
                    <SoftTypography variant="button" color="text" fontWeight="regular">
                      Direkter Support durch unser Partner-Team
                    </SoftTypography>
                  </li>
                  <li>
                    <SoftTypography variant="button" color="text" fontWeight="regular">
                      White-Label Möglichkeiten für Ihre Kunden
                    </SoftTypography>
                  </li>
                </SoftBox>
              </SoftBox>
              
              <SoftBox>
                <SoftTypography variant="h5" fontWeight="medium" mb={2}>
                  So werden Sie Partner
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={3}>
                  Kontaktieren Sie unser Partner-Team und erfahren Sie mehr über unsere Partner-Programme. Wir bieten verschiedene Partnerstufen, die auf Ihre Geschäftsbedürfnisse zugeschnitten sind.
                </SoftTypography>
                <SoftButton 
                  component="a" 
                  href="mailto:partner@uds-solutions.de" 
                  target="_blank" 
                  variant="gradient" 
                  color="info"
                >
                  Partner werden
                </SoftButton>
              </SoftBox>
            </Grid>
          </Grid>
        </SoftBox>
      </Card>
    </SoftBox>
  );
};

export default PartnerInfo;